import React from "react";
import { Handshake, MessageSquare, ClipboardList, FileText } from "lucide-react";
import { motion } from "framer-motion";

const phases = [
    {
      num: "01",
      title: "Tea/Coffee",
      details: ["Open Networking", "Exchange of Cards- Fellowship"],
      color: "from-orange-100 to-orange-200",
      pin: "bg-orange-500",
    },
    {
      num: "02",
      title: "Meeting Starts Sharp 8:30AM",
      details: [
        "Welcome everyone, and introduce Team Leaders and Coordinators",
        "4-Way Test RMB",
        "30-sec members Self Introduction",
      ],
      color: "from-blue-100 to-blue-200",
      pin: "bg-blue-500",
    },
    {
      num: "03",
      title: "Welcome Visitors",
      details: ["Visitors Introduction", "Visitors 30-sec presentation"],
      color: "from-purple-100 to-purple-200",
      pin: "bg-purple-500",
    },
    {
      num: "04",
      title: "Members Business Presentation",
      details: [
        "Introduction of business presentators",
        "10 minutes Business Presentation each",
        "10 minutes knowledge sharing slot",
      ],
      color: "from-orange-100 to-orange-200",
      pin: "bg-orange-500",
    },
    {
      num: "05",
      title: "Announcements",
      details: [
        "Announce Testimonials ,Pass referrals, Thank You, R2Rs",
        "Announcements and reminders",
      ],
      color: "from-blue-100 to-blue-200",
      pin: "bg-blue-500",
    },
    {
      num: "06",
      title: "Prizes & Closing Quote",
      details: [
        "Prize distribution",
        "Closing of meeting by President with a Quote",
      ],
      color: "from-purple-100 to-purple-200",
      pin: "bg-purple-500",
    },
  ];

  const cardVariants = {
  hidden: { opacity: 0, y: 50, scale: 0.9 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { delay: i * 0.2, type: "spring", stiffness: 80 },
  }),
};
export default function Meetingagenda() {
  return (
   <div className="bg-[#101729] min-h-screen flex flex-col justify-center items-center py-16 px-6 w-full">
      {/* Title */}
      <motion.h2
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-4xl font-extrabold text-white mb-16 text-center tracking-wide"
      >
        Meeting Agenda
      </motion.h2>

      <div className="relative w-full max-w-5xl">
        {/* Animated Vertical Line */}
        <motion.div
          initial={{ scaleY: 0 }}
          animate={{ scaleY: 1 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          className="absolute left-1/2 top-0 h-full w-[3px] bg-gradient-to-b from-indigo-500 via-purple-500 to-pink-500 -translate-x-1/2 z-0"
        ></motion.div>

        {phases.map((phase, idx) => (
          <div
            key={idx}
            className={`relative w-full mb-20 flex ${
              idx % 2 === 0 ? "justify-start pr-10" : "justify-end pl-10"
            }`}
          >
            <motion.div
              custom={idx}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              variants={cardVariants}
              className={`bg-gradient-to-br ${phase.color} rounded-2xl shadow-xl p-6 w-[280px] sm:w-[340px] relative z-10 transform transition-all duration-300 hover:scale-105 hover:shadow-2xl`}
            >
              {/* Glowing Pin */}
              <div
                className={`absolute -top-4 left-1/2 -translate-x-1/2 w-8 h-8 ${phase.pin} rounded-full shadow-lg border-4 border-white animate-pulse`}
              ></div>

              {/* Content */}
              <span className="text-[#101729] font-semibold text-5xl">
                {phase.num}
              </span>
              <h3 className="text-[#101729] font-bold text-xl mt-1">
                {phase.title}
              </h3>
              <ul className="mt-3 text-[#101729] text-sm space-y-1">
                {phase.details.map((d, i) => (
                  <li key={i}>• {d}</li>
                ))}
              </ul>
            </motion.div>
          </div>
        ))}
      </div>
    </div>
  );
}
